// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity-tracking .mtp-color {
  color: #0078dc;
}
.activity-tracking #dropdown-activity-types .mx-input-wrapper input {
  margin-top: 0;
}
.activity-tracking #dropdown-activity-types .mx-datepicker {
  padding: 7px;
}
.activity-tracking #dropdown-activity-types .label-date {
  padding: 0 7px 0px 7px;
  margin-bottom: 0;
}
.activity-tracking .show-elements {
  display: inline-block;
  padding-left: 10px;
}
.activity-tracking .accordion-history {
  background-color: #fff;
}
.activity-tracking table {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}
@media (max-width: 767px) {
.activity-tracking table {
    display: block;
}
}
.activity-tracking .table th {
  border-bottom: 1px solid #dee2e6;
}
.activity-tracking .table tr:first-child td:first-child {
  border-top: 1px solid transparent;
}
.activity-tracking .table tr:first-child td:nth-child(2) {
  border-top: 1px solid transparent;
}
.activity-tracking .table th,
.activity-tracking .table td {
  border-top: none;
  border-right: 1px solid #d4d4d4;
  white-space: nowrap;
  background-color: #fff;
  text-align: left;
  padding: 15px;
}
.activity-tracking .table {
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.activity-tracking tr:nth-child(even) td {
  background-color: #f9f9f9;
}
.activity-tracking .table th:first-child {
  width: 5%;
}
.activity-tracking .table th:nth-child(5), .activity-tracking .table td:nth-child(5) {
  border-right: 0;
}
.activity-tracking .card-body {
  padding: 35px 0px;
  padding-bottom: 15px;
  padding-top: 0;
}
.activity-tracking .card-body tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.activity-tracking .arrow {
  cursor: pointer;
  position: relative;
  top: -0.5px;
}
.activity-tracking .number {
  padding: 0 5px;
  font-weight: bold;
  cursor: pointer;
}
.activity-tracking .active {
  color: #0078dc;
}
.activity-tracking .card-header button.btn {
  padding-left: 20px;
}
.activity-tracking .history-filters {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.activity-tracking .history-filters .btn-filter {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  white-space: nowrap;
}
.activity-tracking .history-filters .btn-filter.filterDate {
  max-width: 420px;
}
.activity-tracking .history-filters .btn {
  color: #007bff;
}
.activity-tracking .history-filters .btn .fa-icon {
  margin-top: -2px;
  font-size: 17px;
}
.activity-tracking .history-filters .btn-outline-secondary {
  border: 1px solid #ADADAD;
}
.activity-tracking .history-filters .filters-search {
  margin-left: auto;
}
@media (max-width: 767px) {
.activity-tracking .history-filters .filters-search {
    margin-left: 0;
    flex-basis: 100%;
}
}
.activity-tracking .history-filters .btn-outline-secondary:hover {
  background-color: #0062cc;
}
.activity-tracking .history-filters .btn-outline-secondary:hover .fa-icon {
  color: white;
}
.activity-tracking .history-filters .btn-primary {
  background-color: transparent;
  border: 1px solid #ADADAD;
  box-shadow: none !important;
  color: #007bff;
  margin-right: 5px;
}
.activity-tracking .history-filters .active-filter.btn-primary {
  background-color: #0062cc;
  color: white;
}
.activity-tracking .history-filters .dropdown-divider {
  margin: unset;
  margin-top: 8px;
}
.activity-tracking .history-filters .style-dropdown-filter {
  box-shadow: 2px 5px 9px 0px rgba(0, 0, 0, 0.2);
  padding-bottom: 0;
  z-index: 1029;
}
.activity-tracking .history-filters .section-button .btn {
  padding: 5px 15px;
  margin-top: 0;
}
.activity-tracking .history-filters .section-button .btn:nth-child(2) {
  position: absolute;
  right: 16px;
}
.activity-tracking .history-filters .section-button {
  padding: 5px 10px;
  background-color: #F3F5F7;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.activity-tracking .history-filters .checkmark {
  top: unset;
  margin-top: -6px;
}
.activity-tracking .history-filters button {
  margin-top: 10px;
}
.activity-tracking .history-filters input {
  margin-top: 10px;
}
.activity-tracking .history-filters .input-group-text {
  margin-top: 10px;
}
.activity-tracking .history-filters button:focus {
  box-shadow: none;
}
.activity-tracking label.container {
  max-width: 0;
}
.activity-tracking {
  /* Hide the browser's default checkbox */
}
.activity-tracking .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.activity-tracking {
  /* Create a custom checkbox */
}
.activity-tracking .checkmark {
  position: absolute;
  top: 15px;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  /* background-color: #eee; */
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
.activity-tracking {
  /* When the checkbox is checked, add a blue background */
}
.activity-tracking .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
.activity-tracking {
  /* Create the checkmark/indicator (hidden when not checked) */
}
.activity-tracking .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.activity-tracking {
  /* Show the checkmark when checked */
}
.activity-tracking .container input:checked ~ .checkmark:after {
  display: block;
}
.activity-tracking {
  /* Style the checkmark/indicator */
}
.activity-tracking .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
@media (max-width: 575px) {
.activity-tracking .accordion-history .show-elements {
    display: block;
    padding-left: 0;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
